import { gql } from '@apollo/client';
import { useQuery } from './apollo';

const QUERY = gql`
  query {
    config {
      script { baseUrl }
      survey { baseUrl }
      report { baseUrl }
      matomo { baseUrl }
    }
  }
`;

function useConfig() {
  const { data, loading } = useQuery(QUERY, { networkPolicy: 'cache-first' });

  return { config: data?.config, loading };
}

export default useConfig;
